;(function () {
	'use strict';

	if (!customElements.get('featured-blog')) {
		class FeaturedBlog extends HTMLElement {
			constructor() {
				super();
				this.blogSlider = this.querySelector('.swiper.featured-blog-slider');
				this.swiper = null;
				this.enableSliderDesktop = this.dataset.enableSliderDesktop === 'true';
				this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
			}

			connectedCallback() {
				// Built once (the old code rebuilt the slider on every resize without removing the old one).
				if(this.enableSliderDesktop || this.enableSliderMobile) {
					if (this.blogSlider) {
						this.initSwiper();
					}
				}
			}
		}

		FeaturedBlog.prototype.initSwiper = function() {
			const { gap, gapMobile, slidesPerView, slidesPerViewDesktop, enableSliderDesktop, enableSliderMobile } = this.dataset;

			const sliderInit = () => {
				let spaceBetween = 0;
				let spaceBetweenMb = 0;
				switch (gap) {
					case 'offset-col-lg-3':
						spaceBetween = 30;
						break;
					case 'offset-col-lg-2':
						spaceBetween = 20;
						break;
				}

				if(gapMobile == 'offset-col-sm-2') {
					spaceBetweenMb = 20;
				}

				if (this.swiper) {
					this.swiper.destroy(true, true);
				}

				// Arrows are looked up inside this section only (the old global lookup also grabbed the Creators arrows).
				const nextEl = this.querySelector('.blog-button-next');
				const prevEl = this.querySelector('.blog-button-prev');

				this.swiper = new Swiper(this.blogSlider, {
					loop: false,
					rewind: true,
					speed: 500,
					slidesPerView: 1,
					spaceBetween: 15,
					navigation: {
						nextEl: nextEl,
						prevEl: prevEl,
					},
					pagination: {
						el: this.querySelector('.swiper-pagination'),
						type: "bullets",
						clickable: true
					},
					breakpoints: {
						320: {
							slidesPerView: Number(slidesPerView) || 1.2,
							spaceBetween: spaceBetweenMb,
						},
						750: {
							slidesPerView: Number(slidesPerView) || 2,
							spaceBetween,
						},
						1025: {
							slidesPerView: Number(slidesPerViewDesktop) || 3,
							spaceBetween,
						}
					}
				});
			}

			const sliderWidth = 1200;
			if (enableSliderDesktop == 'false' && enableSliderMobile == 'true' && window.innerWidth < sliderWidth) {
				sliderInit();
			} else if (enableSliderDesktop == 'true' && enableSliderMobile == 'false' && window.innerWidth > sliderWidth ) {
				sliderInit();
			} else if (enableSliderDesktop == 'true' && enableSliderMobile == 'true' ) {
				sliderInit();
			} else {
				if (this.swiper ) {
					this.swiper.destroy()
				}
			};
		};

		customElements.define('featured-blog', FeaturedBlog);
	}
})();
